import { searchMoveableAssets } from 'src/components/pages/MoveableAssets/MoveableAssets.api';

interface SearchResult {
  key: any;
  label: string;
  data?: any;
}

export const moveableAssetSearch = async (
  queryString: string,
): Promise<SearchResult[]> => {
  const response = await searchMoveableAssets({
    code: queryString,
  });

  if (!response.isSuccess || !response.data) {
    return [];
  }

  return response.data.map((asset: any) => ({
    key: asset.id,
    label: asset.code || asset.name || asset.id,
    data: asset,
  }));
};

export const searchStrategy = (
  strategy: string,
  searchSelectKey?: string,
) => {
  const baseFn = (() => {
    switch (strategy) {
      case 'moveable_asset_search':
        return moveableAssetSearch;
      default:
        return async () => [];
    }
  })();

  return async (queryString: string) => {
    const results = await baseFn(queryString);

    if (!searchSelectKey) {
      return results.map((item: any) => ({
        key: item.key,
        label: item.label,
      }));
    }

    return results.map((item: any) => {
      const keyValue = item.data?.[searchSelectKey] || item.key;
      return {
        key: keyValue,
        label: keyValue,
      };
    });
  };
};
